import {Action} from '@ngrx/store';
import {Mensaje} from "../../../../../chacra-core";

export enum MensajesActionTypes {
  MENSAJES_LOAD_REQUEST = '[MENSAJES] Load Request',
  MENSAJES_LOAD_FAILURE = '[MENSAJES] Load Failure',
  MENSAJES_LOAD_SUCCESS = '[MENSAJES] Load Success',
  MENSAJES_ADD_REQUEST = '[MENSAJES] Add Request',
  MENSAJES_ADD_FAILURE = '[MENSAJES] Add Failure',
  MENSAJES_ADD_SUCCESS = '[MENSAJES] Add Success'
}

// load
export class MensajesLoadRequestAction implements Action {
  readonly type = MensajesActionTypes.MENSAJES_LOAD_REQUEST;
}

export class MensajesLoadFailureAction implements Action {
  readonly type = MensajesActionTypes.MENSAJES_LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class MensajesLoadSuccessAction implements Action {
  readonly type = MensajesActionTypes.MENSAJES_LOAD_SUCCESS;

  constructor(public payload: { items: Mensaje[] }) {
  }
}

// add
export class MensajesAddRequestAction implements Action {
  readonly type = MensajesActionTypes.MENSAJES_ADD_REQUEST;

  constructor(public payload: { item: Mensaje }) {
  }
}

export class MensajesAddFailureAction implements Action {
  readonly type = MensajesActionTypes.MENSAJES_ADD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class MensajesAddSuccessAction implements Action {
  readonly type = MensajesActionTypes.MENSAJES_ADD_SUCCESS;

  constructor(public payload: { item: Mensaje }) {
  }
}

// actions
export type MensajesActions =
  | MensajesLoadRequestAction
  | MensajesLoadFailureAction
  | MensajesLoadSuccessAction
  | MensajesAddRequestAction
  | MensajesAddFailureAction
  | MensajesAddSuccessAction;
